module.exports = __webpack_public_path__ + "img/music_play_icon.1e3ce095.png";